/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { FileResponse } from '../models/file-response';

/**
 * file handling apis.
 */
@Injectable({ providedIn: 'root' })
export class WorkOrderFileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `uploadFile()` */
  static readonly UploadFilePath = '/api/v1/files/upload-file';

  /**
   * upload file.
   *
   * This API used to upload file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile$Response(
    params: {
      body: {
        /**
         * An .xlsx attachment file
         */
        files?: Blob;
      };
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FileResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkOrderFileService.UploadFilePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FileResponse>;
        })
      );
  }

  /**
   * upload file.
   *
   * This API used to upload file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile(
    params: {
      body: {
        /**
         * An .xlsx attachment file
         */
        files?: Blob;
      };
    },
    context?: HttpContext
  ): Observable<FileResponse> {
    return this.uploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileResponse>): FileResponse => r.body)
    );
  }
}
